import Vue from 'vue'
import Router from 'vue-router'
import login from '../pages/login.vue'
import no404 from '../pages/404.vue'
import paper from '../pages/paper.vue'
import chooseOrg from '../pages/chooseOrg/chooseOrg.vue'
import typeList from '../pages/chooseType/typeList.vue'
import examList from '../pages/examList/examList.vue'
import problem from '../pages/exam/problem.vue'
import endBack from '../pages/exam/endBack.vue'
import testReport from '../pages/exam/testReport.vue'
import examRecords from '../pages/examRecords/examRecords.vue'
import errProblem from '../pages/examRecords/errProblem.vue'
// 
import myExamList from '../pages/myExamList/myExamlist.vue'
import testManual from '../pages/myExamList/testManual.vue'
import tapeTest from '../pages/myExamList/tapeTest.vue'
import mkfDetection from '../pages/myExamList/mkfDetection.vue'
import youXunCheck from '../pages/myExamList/youXunCheck.vue'
import examination from '../pages/myExamList/examination.vue'
import signCommitment from '../pages/myExamList/signCommitment.vue'
import payOk from '../pages/myExamList/payOk.vue'
import slToWechatQR from '../pages/myExamList/slToWechatQR.vue'

import resultsShow from '../pages/cpResults/resultsShow.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '',
      redirect:{
        name:'登录'
      }
    },{
      path: '/:roadName/login',
      name: '登录',
      component: login
    },{
      path: '/login',
      name: '登录',
      component: login
    },{
      path: '/404',
      name: '',
      component: no404
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/chooseOrg',
          component: chooseOrg,
          name: '选择机构',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/typeList',
          component: typeList,
          name: '科目列表',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/:orgId/examList',
          component: examList,
          name: '试卷列表',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/problem',
          component: problem,
          name: '试卷详情',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/endBack',
          component: endBack,
          name: '考试结束',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/testReport',
          component: testReport,
          name: '测评报告',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/examRecords',
          component: examRecords,
          name: '测评记录',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/errProblem',
          component: errProblem,
          name: '测评记录',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/myExamList',
          component: myExamList,
          name: '我的考试',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/testManual',
          component: testManual,
          name: '查看操作手册',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/tapeTest',
          component: tapeTest,
          name: '教育部问候',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/mkfDetection',
          component: mkfDetection,
          name: '录音检测',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/youXunCheck',
          component: youXunCheck,
          name: '优巡设备检测',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/signCommitment',
          component: signCommitment,
          name: '签署承诺书',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/examination',
          component: examination,
          name: '考试试卷',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/:orgId/resultsShow',
          component: resultsShow,
          name: '测评结果展示',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/payOk',
          component: payOk,
          name: '测评结果展示',
        }
      ]
    },{
      path: '/choose',
      component: paper,
      children: [
        {
          path: '/slToWechatQR',
          component: slToWechatQR,
          name: '支付二维码跳转',
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js